import * as actionTypes from "../actionTypes";
import * as ImmersionGQL from "../../../gql";

export const updateCompareData = (res: any) => ({
  type: actionTypes.UPDATE_COMPARE_DATA,
  payload: res,
});

export const addCompareData = (res: any) => ({
  type: actionTypes.ADD_COMPARE_DATA,
  payload: res,
});

export const addComparePath = (res: any) => ({
  type: actionTypes.ADD_COMPARE_PATH,
  payload: res,
});

export const removeComparePath = () => ({
  type: actionTypes.REMOVE_COMPARE_PATH,
});

export const updateTableSort = (data: string) => ({
  type: actionTypes.UPDATE_TABLE_SORT_COMPARE,
  payload: data,
});

export const initializeSortCompare = () => ({
  type: actionTypes.INITIALIZE_SORTING_COMPARE,
});

export const getCompareTabData = (client: any, req: any, cb: any) => {
  return () => {
    
    client.query({
      query: ImmersionGQL.getCompareTabData,
      fetchPolicy: "no-cache",
      variables: {...req}
    }).then((res: any) => {
      if (res.data.getCompareTabData) {
        const mainData = res.data.getCompareTabData;
        if(mainData.status){
          cb(mainData.data);
        }else{
          cb('')
        }
      }else {
        cb(null);
      }
    }).catch(() => {
      cb(null);
    })
  }
};

export const getCompareBenchMarkData = (client: any, req: any, cb: any) => {
  return () => {
    client.mutate({
      mutation: ImmersionGQL.mutationBenchmarkCompare,
      fetchPolicy: "no-cache",
      variables:{
        session_code: req.session_code,
        user_id: req.user_id,
      }
    }).then((res: any) => {
      if(res?.data?.benchmarkCompareData?.data?.immersion_avg){
        cb(res?.data?.benchmarkCompareData?.data)
      }
    }).catch(() => {
      cb(null);
    })
  }
};

export const getTagWiseData = (client: any, req: any, cb: any) => {
  return () => {
    
    client.query({
      query: ImmersionGQL.queryTagWise,
      fetchPolicy: "no-cache",
      variables: {...req}
    }).then((res: any) => {
      if (res.data.getOverviewData) {
        const mainData = res.data.getOverviewData;
        if(mainData.tag_wise_immersion?.length > 0){
          cb(mainData);
        }else{
          cb('')
        }
      }else {
        cb(null);
      }
    }).catch(() => {
      cb(null);
    })
  }
};